export default "__VITE_ASSET__CEvBoSMe__"